import { render, staticRenderFns } from "./ConteudoVisualListagem.vue?vue&type=template&id=28f37343&scoped=true"
import script from "./ConteudoVisualListagem.vue?vue&type=script&lang=js"
export * from "./ConteudoVisualListagem.vue?vue&type=script&lang=js"
import style0 from "./ConteudoVisualListagem.vue?vue&type=style&index=0&id=28f37343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f37343",
  null
  
)

export default component.exports